// extracted by mini-css-extract-plugin
module.exports = {"frozen":"scroll__frozen--1Q9Bb"};